module.exports = __webpack_public_path__ + "static/img/logo.6e70b34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 582
// module chunks = 70